export default __webpack_public_path__ + "static/media/Maxdol-10-eng.23ef415f.jpg";